var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cc-icons"},_vm._l((_setup.icons),function([src, alt]){return _c('img',{key:src,attrs:{"src":src,"alt":alt}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }